import { useFormContext } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Checkbox } from '@/components/ui/checkbox';
import { QuoteFormSchema } from './schema';
import { ShieldCheck } from 'lucide-react';
import { useGoogleReviews } from '@/context/GoogleReviewsContext';
import AddressFields from '../AddressFields';

export default function Step2Contact() {
	const {
		register,
		formState: { errors },
		setValue,
		watch,
	} = useFormContext<QuoteFormSchema>();
	const googleData = useGoogleReviews();

	const privacyAgreed = watch('privacy_agreed');

	return (
		<div className="space-y-6">
			<div>
				<h3 className="text-2xl font-bold font-heading text-blue-dark mb-4">Stap 2: Uw Gegevens</h3>
				<p className="text-lg text-gray-dark mb-8">Waar kunnen we de offerte naartoe sturen?</p>
			</div>

			<div className="space-y-6">
				<div className="space-y-3">
					<Label htmlFor="location_remarks" className="text-lg">
						Opmerking of vraag <span className="text-gray-400 font-normal">(optioneel)</span>
					</Label>
					<Textarea
						id="location_remarks"
						placeholder="Bijzonderheden waar we rekening mee moeten houden?"
						className="min-h-[120px] text-lg md:text-lg p-3"
						{...register('location_remarks')}
					/>
				</div>

				<div className="space-y-3">
					<Label htmlFor="contact_name" className="text-lg">
						Naam <span className="text-red-500">*</span>
					</Label>
					<Input
						id="contact_name"
						placeholder="Uw volledige naam"
						className={errors.contact_name ? 'border-red-500 h-12 text-lg md:text-lg' : 'h-12 text-lg md:text-lg'}
						{...register('contact_name')}
					/>
					{errors.contact_name && <p className="text-sm text-red-500">{errors.contact_name.message}</p>}
				</div>

				<AddressFields />

				<div className="space-y-3">
					<Label htmlFor="contact_email" className="text-lg">
						E-mailadres <span className="text-red-500">*</span>
					</Label>
					<Input
						id="contact_email"
						type="email"
						placeholder="uw@email.nl"
						className={errors.contact_email ? 'border-red-500 h-12 text-lg md:text-lg' : 'h-12 text-lg md:text-lg'}
						{...register('contact_email')}
					/>
					{errors.contact_email && <p className="text-sm text-red-500">{errors.contact_email.message}</p>}
				</div>

				<div className="space-y-3">
					<Label htmlFor="contact_phone" className="text-lg">
						Telefoonnummer <span className="text-red-500">*</span>
					</Label>
					<Input
						id="contact_phone"
						type="tel"
						placeholder="06 12345678"
						className={errors.contact_phone ? 'border-red-500 h-12 text-lg md:text-lg' : 'h-12 text-lg md:text-lg'}
						{...register('contact_phone')}
					/>
					{errors.contact_phone && <p className="text-sm text-red-500">{errors.contact_phone.message}</p>}
					<p className="text-sm text-gray-500">
						Nodig om even snel een datum voor opname te prikken.
					</p>
				</div>

				<div className="flex items-start space-x-3 pt-6 border-t border-gray-200">
					<Checkbox
						id="privacy_agreed"
						checked={privacyAgreed}
						onCheckedChange={(checked) => setValue('privacy_agreed', checked === true, { shouldValidate: true })}
						className={errors.privacy_agreed ? 'border-red-500 size-5 mt-1' : 'size-5 mt-1 border-gray-400'}
					/>
					<div className="grid gap-1.5 leading-none">
						<Label
							htmlFor="privacy_agreed"
							className="text-lg font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
						>
							Ik ga akkoord met de privacyverklaring <span className="text-red-500">*</span>
						</Label>
						<p className="text-sm text-gray-500">
							Wij gebruiken uw gegevens alleen om contact met u op te nemen over uw aanvraag.
						</p>
						{errors.privacy_agreed && <p className="text-sm text-red-500">{errors.privacy_agreed.message}</p>}
					</div>
				</div>

				<div className="flex items-center gap-2 mt-4 text-sm font-medium text-green-700 bg-green-50 p-3 rounded-md border border-green-100">
					<ShieldCheck className="size-5" />
					<span>Gecertificeerd Airco Installateur met een {googleData.rating.toFixed(1)} sterren Google Rating</span>
				</div>
			</div>
		</div>
	);
}
